export default function About() {
    return (<div
        className="page-company__about tab-pane fade show active"
    >
        <picture>
            <source srcSet="/img/temp/001.png" media="(max-width: 992px)"/>
            <img src="/img/temp/000.png" alt=""/>
        </picture>
    </div>)
}